import { Grid } from '@mui/material';
import { NextPage } from 'next';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { memo, useState } from 'react';

import useBreakpoints from '../../components/Hooks/useBreakpoints';
import contato from '../../public/img/contato/contato.png';
import contatoMobile from '../../public/img/mobile/contato.webp';

const Form = dynamic(() => import('../../components/Form'));
const Line = dynamic(() => import('../../components/Line'));
const ModalExpert = dynamic(() => import('../../components/ModalExpert'));

const Contato: NextPage = () => {
  const [send, setSend] = useState(false);
  const { isDesktop } = useBreakpoints();
  return (
    <Grid
      item
      container
      justifyContent={{ xs: 'center', lg: 'flex-start' }}
      alignContent={'center'}
      alignItems={'center'}
      direction="row"
      xs={12}
      position="relative"
    >
      <Grid
        item
        container
        direction="column"
        justifyContent={'center'}
        alignContent={'center'}
        xs={12}
        lg={6}
        gap={'24px'}
      >
        <Grid item className="barlow--size32 bold">
          Contato
        </Grid>
        <Grid item className="open-sans--size18">
          Vamos marcar uma reunião e bater um papo para descobrir como fazer seu
          projeto <span className="green">#</span>
          <span className="blue">shiftyourevolution</span>?
        </Grid>
        <Grid item className="open-sans--size18 bold">
          Preencha o formulário aqui. É rapidinho, a gente promete!
        </Grid>
        <Grid item>
          <Form setSend={setSend} />
          {send && <ModalExpert hasSend={send} setSend={setSend} />}
        </Grid>
        <Grid item>
          <Line />
        </Grid>
      </Grid>
      <Grid
        item
        container
        position={{ lg: 'absolute' }}
        right={-450}
        top={0}
        alignContent={'center'}
        alignItems={'center'}
        justifyContent={'center'}
        zIndex={-1}
      >
        {isDesktop ? (
          <Image
            src={contato.src}
            alt="contato"
            height={'650px'}
            width={'1150'}
          />
        ) : (
          <Image
            src={contatoMobile.src}
            alt="contato"
            height={'442px'}
            width={'358px'}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default memo(Contato);
